
<div class="entry_values" >
  <div class="entry"  *ngFor="let storageLocation of storageLocationArrayForm.get('StorageLocations')['controls']; index as i"
  (click)="onEdit(storageLocation.value, i)"
  style="cursor: pointer;"
  >
    <div class="other_info">
      <p class="no_index">{{i + 1}}.</p>
      <p class="purpose">
        <span>File Location: </span>
        <span>{{getFileLocationName(storageLocation?.value.FileLocationId)}}</span>
      </p>

      <p class="net_area">
        <span>Cabinet/Ref: </span>
        <span>{{getCabinetName(storageLocation?.value.CabinetShelfRefId)}}</span>
      </p>

      <p class="net_area">
        <span>Rack/ Tray: </span>
        <span>{{getRackName(storageLocation?.value.RackTrayRefId)}}</span>
      </p>

      <p class="net_area">
        <span>Remark: </span>
        <span>{{storageLocation?.value.FiscalFileRemarks}}</span>
      </p>

      <p class="info" (click)="$event.stopImmediatePropagation()">
        <i class="ti-trash" (click)="onDelete(storageLocation.value, i)"></i>
      </p>
    </div>
  </div>
  </div>
